import { z } from "zod";
import { PromoAppliedSchema } from "./promo";
export const PlanSchema = z.enum(["free", "premium"]);
export const LocaleSchema = z.enum(["pl", "en", "de"]);
export const CurrencySchema = z.enum([
    "PLN",
    "EUR",
    "USD",
    "GBP",
    "CZK",
    "HUF",
    "CHF",
    "NOK",
    "SEK",
    "DKK",
    "RON",
    "BGN",
]);
/**
 * Sensible default currency per app locale: Polish/English audiences keep PLN
 * (the product's original currency); German audiences default to EUR. Used
 * by `ensureUserDoc` and new-wedding onboarding so a freshly seeded German
 * user starts in EUR without an extra settings trip.
 */
export function defaultCurrencyForLocale(locale) {
    return locale === "de" ? "EUR" : "PLN";
}
export const UserSchema = z.object({
    id: z.string(),
    email: z.string().email(),
    displayName: z.string().nullable().describe("Firebase Auth profile mirror — usually 'P1 & P2'"),
    coupleName1: z.string().nullable().describe("The registering user's first name"),
    coupleName2: z
        .string()
        .nullable()
        .describe("Their partner's first name; null after Google sign-in until onboarding"),
    photoURL: z.string().url().nullable(),
    locale: LocaleSchema.default("pl"),
    currency: CurrencySchema.default("PLN"),
    plan: PlanSchema.default("free"),
    stripeCustomerId: z.string().nullable().optional(),
    mollieCustomerId: z.string().nullable().optional(),
    mollieSubscriptionId: z.string().nullable().optional(),
    planValidUntil: z.string().datetime().nullable().optional(),
    promoApplied: PromoAppliedSchema.nullable().optional(),
    partnerId: z.string().nullable().optional(),
    isDemo: z.boolean().default(false).optional(),
    emailVerified: z.boolean().default(false),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
